import { useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Form, Modal, Row, Table } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Authenticator from '../authenticator';
import Loading from '../components/loading';
import SuccessMessage from '../components/successMessage';
import ErrorMessage from '../components/errorMessage';
import Select from 'react-select';
import api from '../api/api';

export default function PilotDosage() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showPilotDosageResult, setShowConcreteDosageResult] = useState(false);

  const [showModalToAddPilotDosage, setShowModalToAddPilotDosage] = useState(false);
  const [showReceiptConcreteModal, setShowReceiptConcreteModal] = useState(false);

  const [nameToAdd, setNameToAdd] = useState('');
  const [mortarPercentageToAdd, setMortarPercentageToAdd] = useState('');
  const [cementConsumptionPerCubicMeterToAdd, setCementConsumptionPerCubicMeterToAdd] = useState('');
  const [waterConsumptionPerCubicMeterToAdd, setWaterConsumptionPerCubicMeterToAdd] = useState('');
  const [additiveConsumptionToAdd, setAdditiveConsumptionToAdd] = useState('');
  const [incorporatedAirToAdd, setIncorporatedAirToAdd] = useState('');

  // New state variables for additional fields
  const [codeToAdd, setCodeToAdd] = useState('');
  const [dateToAdd, setDateToAdd] = useState('');
  const [specificMassToAdd, setSpecificMassToAdd] = useState('');
  const [maximumDiameterToAdd, setMaximumDiameterToAdd] = useState('');
  const [waterCementRatioToAdd, setWaterCementRatioToAdd] = useState('');
  const [sandsFinenessModuleToAdd, setSandsFinenessModuleToAdd] = useState('');
  const [resistanceToAdd, setResistanceToAdd] = useState('');
  const [slumpToAdd, setSlumpToAdd] = useState('');
  const [volumeToAdd, setVolumeToAdd] = useState('');

  const [comboBoxOptionsToNonAggregateMaterials, setcomboBoxOptionsToNonAggregateMaterials] = useState([]);
  const [comboBoxOptionsToSands, setcomboBoxOptionsToSands] = useState([]);
  const [comboBoxOptionsToGravels, setcomboBoxOptionsToGravels] = useState([]);
  const [comboBoxOptionsToAdditives, setcomboBoxOptionsToAdditives] = useState([]);

  const [nonAggregateMaterialsToAdd, setNonAggregateMaterialsToAdd] = useState([]);

  const [gravelToAdd, setGravelToAdd] = useState('');
  const [percentageFromGravelToAdd, setPercentageFromGravelToAdd] = useState('');
  const [gravelsAndPercentagesToAdd, setGravelsAndPercentagesToAdd] = useState([]);

  const [sandToAdd, setSandToAdd] = useState('');
  const [percentageFromSandToAdd, setPercentageFromSandToAdd] = useState('');
  const [sandsAndPercentagesToAdd, setSandsAndPercentagesToAdd] = useState([]);

  // Other additives state
  const [otherAdditiveToAdd, setOtherAdditiveToAdd] = useState('');
  const [otherAdditivePercentageToAdd, setOtherAdditivePercentageToAdd] = useState('');
  const [otherAdditivesAndPercentagesToAdd, setOtherAdditivesAndPercentagesToAdd] = useState([]);

  const [receiptFromConcrete, setReceiptFromConcrete] = useState('');
  const [gravelsQuantitiesPerCubicMeter, setGravelsQuantitiesPerCubicMeter] = useState([]);
  const [sandsQuantitiesPerCubicMeter, setSandsQuantitiesPerCubicMeter] = useState([]);

  const [registeredConcreteDosages, setRegisteredConcreteDosages] = useState([]);
  const [registeredConcreteDosage, setRegisteredConcreteDosage] = useState('');

  const [showRegisteredConcreteDosageModal, setShowRegisteredPilotDosageModal] = useState(false);

  function sanitizeNumericInput(value) {
    return value.replace(/[^0-9.,]/g, '');
  }

  useEffect(() => {
    getMaterials();
  }, []);

  function getMaterials() {
    getAllRegisteredPilotDosages();
    getNonAggregateMaterials();
    getGravels();
    getSands();
    getAllAdditivesToComboBox();
  }

  function getAllRegisteredPilotDosages() {
    setLoading(true);
    api
      .get('/pilot-dosage', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setRegisteredConcreteDosages(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getNonAggregateMaterials() {
    setLoading(true);
    api
      .get('/materials/non-aggregate', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToNonAggregateMaterials(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getGravels() {
    setLoading(true);
    api
      .get('/materials/gravels/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToGravels(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getSands() {
    setLoading(true);
    api
      .get('/materials/sands/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToSands(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getAllAdditivesToComboBox() {
    setLoading(true);
    api
      .get('/materials/others-additives/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToAdditives(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function closeModalToAddDosage() {
    setShowModalToAddPilotDosage(false);
  }

  function closeReceiptConcreteModal() {
    setShowReceiptConcreteModal(false);
  }

  function addGravel() {
    const gravel = {
      gravelToAdd: gravelToAdd,
      percentageFromGravelToAdd: percentageFromGravelToAdd
    };

    gravelsAndPercentagesToAdd.push(gravel);

    setGravelToAdd('');
    setPercentageFromGravelToAdd('');
  }

  function deleteGravelFromList(gravel) {
    const gravelIndex = sandsAndPercentagesToAdd.indexOf(gravel);

    if (gravelIndex > -1) {
      sandsAndPercentagesToAdd.splice(gravelIndex, 1);
    }
  }

  function addSand() {
    const sand = {
      sandToAdd: sandToAdd,
      percentageFromSandToAdd: percentageFromSandToAdd
    };
    sandsAndPercentagesToAdd.push(sand);

    setSandToAdd('');
    setPercentageFromSandToAdd('');
  }

  function deleteGravelFromList(gravel) {
    const gravelIndex = sandsAndPercentagesToAdd.indexOf(gravel);

    if (gravelIndex > -1) {
      sandsAndPercentagesToAdd.splice(gravelIndex, 1);
    }
  }

  function deleteSandFromList(sand) {
    const sandIndex = sandsAndPercentagesToAdd.indexOf(sand);

    if (sandIndex > -1) {
      sandsAndPercentagesToAdd.splice(sandIndex, 1);
    }
  }

  function addOtherAdditive() {
    if (!otherAdditiveToAdd || !otherAdditivePercentageToAdd) {
      setShowErrorMessage(true);
      setErrorMessage('Por favor, selecione um aditivo e informe a porcentagem.');
      return;
    }

    const additive = {
      additiveToAdd: otherAdditiveToAdd,
      percentageFromAdditiveToAdd: otherAdditivePercentageToAdd
    };

    otherAdditivesAndPercentagesToAdd.push(additive);

    setOtherAdditiveToAdd('');
    setOtherAdditivePercentageToAdd('');
  }

  function deleteOtherAdditiveFromList(additive) {
    const additiveIndex = otherAdditivesAndPercentagesToAdd.indexOf(additive);

    if (additiveIndex > -1) {
      otherAdditivesAndPercentagesToAdd.splice(additiveIndex, 1);
    }
  }

  const addPilotDosage = (event) => {
    event.preventDefault();
    setLoading(true);
    const input = {
      name: nameToAdd,
      code: codeToAdd,
      date: dateToAdd,
      mortarPercentage: mortarPercentageToAdd,
      cementConsumptionPerCubicMeter: cementConsumptionPerCubicMeterToAdd,
      waterConsumptionPerCubicMeter: waterConsumptionPerCubicMeterToAdd,
      additiveConsumptionPercentage: additiveConsumptionToAdd,
      percentageOfincorporatedAir: incorporatedAirToAdd,
      specificMass: specificMassToAdd,
      maximumDiameter: maximumDiameterToAdd,
      waterCementRatio: waterCementRatioToAdd,
      sandsFinenessModule: sandsFinenessModuleToAdd,
      resistance: resistanceToAdd,
      slump: slumpToAdd,
      volume: volumeToAdd,
      nonAggregateMaterials: nonAggregateMaterialsToAdd.map((item) => ({
        materialId: item.value
      })),
      gravelsAndPercentages: gravelsAndPercentagesToAdd.map((item) => ({
        gravelId: item.gravelToAdd.value,
        percentage: item.percentageFromGravelToAdd
      })),
      sandsAndPercentages: sandsAndPercentagesToAdd.map((item) => ({
        sandId: item.sandToAdd.value,
        percentage: item.percentageFromSandToAdd
      })),
      otherAdditivesAndPercentages: otherAdditivesAndPercentagesToAdd.map((item) => ({
        additiveId: item.additiveToAdd.value,
        percentage: item.percentageFromAdditiveToAdd
      }))
    };

    api
      .post('/pilot-dosage/add', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setShowModalToAddPilotDosage(false);
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
        getAllRegisteredPilotDosages();
      })
      .catch((error) => {
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  };

  const calculateReceipt = (event) => {
    setLoading(true);
    const input = {
      name: nameToAdd,
      code: codeToAdd,
      date: dateToAdd,
      mortarPercentage: mortarPercentageToAdd,
      cementConsumptionPerCubicMeter: cementConsumptionPerCubicMeterToAdd,
      waterConsumptionPerCubicMeter: waterConsumptionPerCubicMeterToAdd,
      additiveConsumptionPercentage: additiveConsumptionToAdd,
      percentageOfincorporatedAir: incorporatedAirToAdd,
      specificMass: specificMassToAdd,
      maximumDiameter: maximumDiameterToAdd,
      waterCementRatio: waterCementRatioToAdd,
      sandsFinenessModule: sandsFinenessModuleToAdd,
      resistance: resistanceToAdd,
      slump: slumpToAdd,
      volume: volumeToAdd,
      nonAggregateMaterials: nonAggregateMaterialsToAdd.map((item) => ({
        materialId: item.value
      })),
      gravelsAndPercentages: gravelsAndPercentagesToAdd.map((item) => ({
        gravelId: item.gravelToAdd.value,
        percentage: item.percentageFromGravelToAdd
      })),
      sandsAndPercentages: sandsAndPercentagesToAdd.map((item) => ({
        sandId: item.sandToAdd.value,
        percentage: item.percentageFromSandToAdd
      })),
      otherAdditivesAndPercentages: otherAdditivesAndPercentagesToAdd.map((item) => ({
        additiveId: item.additiveToAdd.value,
        percentage: item.percentageFromAdditiveToAdd
      }))
    };

    api
      .post('/pilot-dosage/simulate-receipt', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setReceiptFromConcrete(returnFromApi.data);
        setGravelsQuantitiesPerCubicMeter(returnFromApi.data.gravelsQuantitiesPerCubicMeter);
        setSandsQuantitiesPerCubicMeter(returnFromApi.data.sandsQuantitiesPerCubicMeter);
        setShowReceiptConcreteModal(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error.response.data);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  };

  function openModalToViewConcreteDosage(pilotDosage) {
    setLoading(true);
    api
      .get('/pilot-dosage/view/' + pilotDosage.pilotDosageId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setRegisteredConcreteDosage(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });

    setShowRegisteredPilotDosageModal(true);
  }

  function deletePilotDosage(pilotDosage) {
    setLoading(true);
    api
      .delete('/pilot-dosage/' + pilotDosage.pilotDosageId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setSuccessMessage(returnFromApi.data);
        setShowSuccessMessage(true);
        getAllRegisteredPilotDosages();
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(returnFromApi.data);
        setShowErrorMessage(true);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function closeRegisteredPilotDosageModal() {
    setShowRegisteredPilotDosageModal(false);
  }

  return (
    <Card className="bg-transparent-50 overflow-hidden">
      <Authenticator />
      <Card.Header className="position-relative">
        <div className="row flex-between-center">
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

          <div className="col col-lg-8">
            <h5 className="mb-0 texto-negrito">Dosagens Piloto Cadastradas</h5>
          </div>
          <div className="col-12 col-sm-auto ms-auto">
            <Button variant="falcon-primary" className="me-2 mb-1" onClick={() => setShowModalToAddPilotDosage(true)}>
              Cadastrar Nova Dosagem
            </Button>
          </div>
        </div>

        <Loading isToHidden={isLoading == false} />

        <div hidden={isLoading}>
          <div className="text-center" hidden={registeredConcreteDosages.length > 0}>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
              Nenhuma dosagem piloto cadastrada ainda.
            </p>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0" hidden={registeredConcreteDosages.length == 0}>
        <Table responsive className={`form-container ${isLoading ? 'loading' : ''}`}>
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th className="text-end" scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {registeredConcreteDosages.map((concreteDosage) => {
              return (
                <tr key={concreteDosage.concreteDosageId}>
                  <td>{concreteDosage.name}</td>
                  <td className="text-end">
                    <Dropdown className="d-inline-block ms-2">
                      <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                      <Dropdown.Menu className="py-2">
                        <Dropdown.Item as={Link} onClick={() => openModalToViewConcreteDosage(concreteDosage)}>
                          Visualizar
                        </Dropdown.Item>
                        <Dropdown.Divider as="div" />
                        <Dropdown.Item
                          as={Link}
                          onClick={() => deletePilotDosage(concreteDosage)}
                          className="text-danger"
                        >
                          Excluir
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>

      <Modal
        show={showModalToAddPilotDosage}
        backdrop="static"
        keyboard={false}
        onHide={() => closeModalToAddDosage()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Dosagem Piloto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Loading isToHidden={isLoading == false} />
          <Form
            onSubmit={addPilotDosage}
            className={`form-container ${showReceiptConcreteModal || isLoading ? 'loading' : 'mt-3'}`}
          >
            {/* Receita de concreto Section */}
            <div className="mb-4">
              <h4 className="mb-3 text-dark fw-bold">Receita de concreto</h4>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Nome da dosagem:</Form.Label>
                    <Form.Control type="text" value={nameToAdd} onChange={(e) => setNameToAdd(e.target.value)} />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Código:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Código da dosagem"
                      value={codeToAdd}
                      onChange={(e) => setCodeToAdd(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Data:</Form.Label>
                    <Form.Control type="date" value={dateToAdd} onChange={(e) => setDateToAdd(e.target.value)} />
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Parâmetros do concreto Section */}
            <div className="mb-4">
              <h4 className="mb-3 text-dark fw-bold">Parâmetros do concreto</h4>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Teor de argamassa (%):</Form.Label>
                    <Form.Control
                      type="text"
                      value={mortarPercentageToAdd}
                      onChange={(e) => setMortarPercentageToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Ar incorporado (%):</Form.Label>
                    <Form.Control
                      type="text"
                      value={incorporatedAirToAdd}
                      onChange={(e) => setIncorporatedAirToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Consumo de cimento por m³:</Form.Label>
                    <Form.Control
                      type="text"
                      value={cementConsumptionPerCubicMeterToAdd}
                      onChange={(e) => setCementConsumptionPerCubicMeterToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Massa específica (kg/m³):</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Massa específica"
                      value={specificMassToAdd}
                      onChange={(e) => setSpecificMassToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Consumo de água por m³:</Form.Label>
                    <Form.Control
                      type="text"
                      value={waterConsumptionPerCubicMeterToAdd}
                      onChange={(e) => setWaterConsumptionPerCubicMeterToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Diâmetro máximo (mm):</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Diâmetro máximo"
                      value={maximumDiameterToAdd}
                      onChange={(e) => setMaximumDiameterToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Relação água/cimento:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Relação água/cimento"
                      value={waterCementRatioToAdd}
                      onChange={(e) => setWaterCementRatioToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Módulo de finura areias:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Módulo de finura"
                      value={sandsFinenessModuleToAdd}
                      onChange={(e) => setSandsFinenessModuleToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Resistência (MPa):</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Resistência"
                      value={resistanceToAdd}
                      onChange={(e) => setResistanceToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Slump (mm):</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Slump"
                      value={slumpToAdd}
                      onChange={(e) => setSlumpToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Volume de Concreto Section */}
            <div className="mb-4">
              <h4 className="mb-3 text-dark fw-bold">Volume de Concreto</h4>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Volume de Concreto (m³):</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Volume de concreto"
                      value={volumeToAdd}
                      onChange={(e) => setVolumeToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Aditivos Section */}
            <div className="mb-4">
              <h4 className="mb-3 text-dark fw-bold">Aditivos</h4>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Consumo de aditivo (%)</Form.Label>
                    <Form.Control
                      type="text"
                      value={additiveConsumptionToAdd}
                      onChange={(e) => setAdditiveConsumptionToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {/* <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Outros aditivos</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      options={comboBoxOptionsToAdditives}
                      placeholder="Selecione..."
                      classNamePrefix="react-select"
                      value={otherAdditiveToAdd}
                      onChange={(value) => setOtherAdditiveToAdd(value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Porcentagem</Form.Label>
                    <Form.Control
                      type="text"
                      value={otherAdditivePercentageToAdd}
                      onChange={(e) => setOtherAdditivePercentageToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Button className="mt-4" variant="primary" onClick={() => addOtherAdditive()}>
                    Adicionar
                  </Button>
                </Col>
              </Row> */}
              <Row>
                <Col xs={12}>
                  <Table responsive hidden={otherAdditivesAndPercentagesToAdd.length === 0}>
                    <thead>
                      <tr>
                        <th scope="col">Outros Aditivos</th>
                        <th scope="col">Porcentagem</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {otherAdditivesAndPercentagesToAdd.map((additive, index) => {
                        return (
                          <tr key={index}>
                            <td>{additive.additiveToAdd.label}</td>
                            <td>{additive.percentageFromAdditiveToAdd}%</td>
                            <td className="text-end">
                              <Dropdown className="d-inline-block ms-2">
                                <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    as={Link}
                                    onClick={() => deleteOtherAdditiveFromList(additive)}
                                    className="text-danger"
                                  >
                                    Excluir
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>

            {/* Materiais Section */}
            <div className="mb-4">
              <h4 className="mb-3 text-dark fw-bold">Materiais não agregados</h4>
              <Row>
                <Col xs={12}>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToNonAggregateMaterials}
                    placeholder="Selecione..."
                    isMulti
                    classNamePrefix="react-select"
                    value={nonAggregateMaterialsToAdd}
                    onChange={(value) => setNonAggregateMaterialsToAdd(value)}
                  />
                </Col>
              </Row>
            </div>

            {/* Britas e porcentagens de uso Section */}
            <div className="mb-4">
              <h4 className="mb-3 text-dark fw-bold">Britas e porcentagens de uso</h4>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Brita</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      options={comboBoxOptionsToGravels}
                      placeholder="Selecione..."
                      classNamePrefix="react-select"
                      value={gravelToAdd}
                      onChange={(value) => setGravelToAdd(value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Porcentagem</Form.Label>
                    <Form.Control
                      type="text"
                      value={percentageFromGravelToAdd}
                      onChange={(e) => setPercentageFromGravelToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Button className="mt-4" onClick={() => addGravel()}>
                    Adicionar
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Table responsive hidden={gravelsAndPercentagesToAdd.length === 0}>
                    <thead>
                      <tr>
                        <th scope="col">Brita</th>
                        <th scope="col">Porcentagem</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {gravelsAndPercentagesToAdd.map((gravel) => {
                        return (
                          <tr key={gravel.gravelToAdd.value}>
                            <td>{gravel.gravelToAdd.label}</td>
                            <td>{gravel.percentageFromGravelToAdd}</td>
                            <td className="text-end">
                              <Dropdown className="d-inline-block ms-2">
                                <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    as={Link}
                                    onClick={() => deleteGravelFromList(gravel)}
                                    className="text-danger"
                                  >
                                    Excluir
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>

            {/* Areias e porcentagens de uso Section */}
            <div className="mb-4">
              <h4 className="mb-3 text-dark fw-bold">Areias e porcentagens de uso</h4>
              <Row>
                <Col xs={12} md={6}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Areia</Form.Label>
                    <Select
                      closeMenuOnSelect={false}
                      options={comboBoxOptionsToSands}
                      placeholder="Selecione..."
                      classNamePrefix="react-select"
                      value={sandToAdd}
                      onChange={(value) => setSandToAdd(value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group className="mb-3" controlId="titleInput">
                    <Form.Label className="fs-9">Porcentagem</Form.Label>
                    <Form.Control
                      type="text"
                      value={percentageFromSandToAdd}
                      onChange={(e) => setPercentageFromSandToAdd(sanitizeNumericInput(e.target.value))}
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={2}>
                  <Button className="mt-4" onClick={() => addSand()}>
                    Adicionar
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Table responsive hidden={sandsAndPercentagesToAdd.length === 0}>
                    <thead>
                      <tr>
                        <th scope="col">Areia</th>
                        <th scope="col">Porcentagem</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {sandsAndPercentagesToAdd.map((sand) => {
                        return (
                          <tr key={sand.sandToAdd.value}>
                            <td>{sand.sandToAdd.label}</td>
                            <td>{sand.percentageFromSandToAdd}</td>
                            <td className="text-end">
                              <Dropdown className="d-inline-block ms-2">
                                <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    as={Link}
                                    onClick={() => deleteSandFromList(sand)}
                                    className="text-danger"
                                  >
                                    Excluir
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="falcon-primary" className="me-3" onClick={() => calculateReceipt()}>
                Simular Receita
              </Button>
              <Button type="submit">Salvar</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showReceiptConcreteModal}
        backdrop="static"
        keyboard={false}
        onHide={() => closeReceiptConcreteModal()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Receita do Concreto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={5}>Massa de Aditivo por Metro Cúbico:</Col>
            <Col>{receiptFromConcrete.formattedAdditiveMassPerCubicMeter}</Col>
          </Row>
          <Row>
            <Col xs={5}>Massa de Cimento:</Col>
            <Col>{receiptFromConcrete.formattedCementMass}</Col>
          </Row>
          <Row>
            <Col xs={5}>Resistência do Concreto:</Col>
            <Col>{receiptFromConcrete.formattedConcreteResistence}</Col>
          </Row>
          <Row>
            <Col xs={5}>Slump:</Col>
            <Col>{receiptFromConcrete.formattedSlump}</Col>
          </Row>
          <Row>
            <Col xs={5}>Massa Específica:</Col>
            <Col>{receiptFromConcrete.formattedSpecificMass}</Col>
          </Row>
          <Row>
            <Col xs={5}>Viscosidade:</Col>
            <Col>{receiptFromConcrete.formattedViscosity}</Col>
          </Row>
          <Row>
            <Col xs={5}>Massa de Água:</Col>
            <Col>{receiptFromConcrete.formattedWaterMass}</Col>
          </Row>
          <hr color="#424242" size="2"></hr>
          <h4>Britas por metro cúbico</h4>
          {gravelsQuantitiesPerCubicMeter.map((gravel) => {
            return (
              <Row>
                <Col xs={5}>{gravel.formattedGravelName}</Col>
                <Col>{gravel.formattedQuantity}</Col>
              </Row>
            );
          })}
          <hr color="#424242" size="2"></hr>
          <h4>Areias por metro cúbico</h4>
          {sandsQuantitiesPerCubicMeter.map((sand) => {
            return (
              <Row>
                <Col xs={5}>{sand.formattedSandName}</Col>
                <Col>{sand.formattedQuantity}</Col>
              </Row>
            );
          })}
          <hr color="#424242" size="2"></hr>
        </Modal.Body>
      </Modal>

      <Modal
        show={showRegisteredConcreteDosageModal}
        backdrop="static"
        keyboard={false}
        onHide={() => closeRegisteredPilotDosageModal()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Dosagem Piloto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={5}>Dosagem:</Col>
            <Col>{registeredConcreteDosage.name}</Col>
          </Row>
          <Row>
            <Col xs={5}>Teor de Argamassa:</Col>
            <Col>{registeredConcreteDosage.mortarPercentage}</Col>
          </Row>
          <Row>
            <Col xs={5}>Ar Incorporado:</Col>
            <Col>{registeredConcreteDosage.percentageOfincorporatedAir}</Col>
          </Row>
          <Row>
            <Col xs={5}>Consumo de Aditivo</Col>
            <Col>{registeredConcreteDosage.additiveConsumptionPercentage}</Col>
          </Row>
          <Row>
            <Col xs={5}>Consumo de Água por metro cúbico</Col>
            <Col>{registeredConcreteDosage.waterConsumptionPerCubicMeter}</Col>
          </Row>
          <hr color="#424242" size="2"></hr>
          <h4>Materiais Não Agregados</h4>
          {registeredConcreteDosage?.nonAggregateMaterials?.length > 0 &&
            registeredConcreteDosage.nonAggregateMaterials.map((nonAggregateMaterial, index) => {
              return (
                <Row key={index}>
                  <Col xs={5}>{nonAggregateMaterial.name}</Col>
                </Row>
              );
            })}
          <hr color="#424242" size="2"></hr>
          <h4>Britas e Porcentagens de uso</h4>
          {registeredConcreteDosage?.gravelsAndPercentages?.length > 0 &&
            registeredConcreteDosage.gravelsAndPercentages.map((gravel, index) => {
              return (
                <Row key={index}>
                  <Col xs={5}>{gravel.name}</Col>
                  <Col>{gravel.percentage}</Col>
                </Row>
              );
            })}

          <hr color="#424242" size="2"></hr>
          <h4>Areias e Porcentagens de uso</h4>
          {registeredConcreteDosage?.sandsAndPercentages?.length > 0 &&
            registeredConcreteDosage.sandsAndPercentages.map((sand, index) => {
              return (
                <Row key={index}>
                  <Col xs={5}>{sand.name}</Col>
                  <Col>{sand.percentage}</Col>
                </Row>
              );
            })}

          {registeredConcreteDosage?.receiptFromConcrete && (
            <>
              <hr color="#424242" size="2" />
              <h4>Receita do Concreto</h4>

              <Row>
                <Col xs={5}>Massa de Aditivo por Metro Cúbico:</Col>
                <Col>{registeredConcreteDosage.receiptFromConcrete.formattedAdditiveMassPerCubicMeter}</Col>
              </Row>
              <Row>
                <Col xs={5}>Massa de Cimento:</Col>
                <Col>{registeredConcreteDosage.receiptFromConcrete.formattedCementMass}</Col>
              </Row>
              <Row>
                <Col xs={5}>Resistência do Concreto:</Col>
                <Col>{registeredConcreteDosage.receiptFromConcrete.formattedConcreteResistence}</Col>
              </Row>
              <Row>
                <Col xs={5}>Slump:</Col>
                <Col>{registeredConcreteDosage.receiptFromConcrete.formattedSlump}</Col>
              </Row>
              <Row>
                <Col xs={5}>Massa Específica:</Col>
                <Col>{registeredConcreteDosage.receiptFromConcrete.formattedSpecificMass}</Col>
              </Row>
              <Row>
                <Col xs={5}>Viscosidade:</Col>
                <Col>{registeredConcreteDosage.receiptFromConcrete.formattedViscosity}</Col>
              </Row>
              <Row>
                <Col xs={5}>Massa de Água:</Col>
                <Col>{registeredConcreteDosage.receiptFromConcrete.formattedWaterMass}</Col>
              </Row>

              {registeredConcreteDosage.receiptFromConcrete.gravelsQuantitiesPerCubicMeter?.length > 0 && (
                <>
                  <hr color="#424242" size="2" />
                  <h4>Britas por metro cúbico</h4>
                  {registeredConcreteDosage.receiptFromConcrete.gravelsQuantitiesPerCubicMeter.map((gravel, index) => (
                    <Row key={index}>
                      <Col xs={5}>{gravel.formattedGravelName}</Col>
                      <Col>{gravel.formattedQuantity}</Col>
                    </Row>
                  ))}
                </>
              )}

              {registeredConcreteDosage.receiptFromConcrete.sandsQuantitiesPerCubicMeter?.length > 0 && (
                <>
                  <hr color="#424242" size="2" />
                  <h4>Areias por metro cúbico</h4>
                  {registeredConcreteDosage.receiptFromConcrete.sandsQuantitiesPerCubicMeter.map((sand, index) => (
                    <Row key={index}>
                      <Col xs={5}>{sand.formattedSandName}</Col>
                      <Col>{sand.formattedQuantity}</Col>
                    </Row>
                  ))}
                </>
              )}
            </>
          )}
          <hr color="#424242" size="2"></hr>
        </Modal.Body>
      </Modal>
    </Card>
  );
}
